import { createApp } from 'vue';
import PrimeVue from "primevue/config";
import Aura from '@primeuix/themes/aura';
import { initializeApp } from 'firebase/app'; // Import firebase app
import { getDatabase } from 'firebase/database';

import App from './App.vue';
import router from './router';


// Import CSS files from node_modules
import 'uikit/dist/css/uikit.min.css';
import 'aos/dist/aos.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@/assets/css/swiper-bundle.min.css';
import '@/assets/css/fonts.css';
import '@/assets/css/shared.css';
import '/node_modules/primeflex/primeflex.css';
import 'primeicons/primeicons.css';

// Import JavaScript files from node_modules
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import AOS from 'aos';
// import { Fancybox } from '@fancyapps/ui';
// import Swiper from 'swiper/bundle';

// Initialize UIkit icons
UIkit.use(Icons);

// Initialize AOS
AOS.init();

const firebaseConfig = {
  apiKey: "AIzaSyDOWxLCYE6lpaaoGKQgBw4jqzx6HksSfw4",
  authDomain: "project-our-day.firebaseapp.com",
  databaseURL: "https://project-our-day-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "project-our-day",
  storageBucket: "project-our-day.firebasestorage.app",
  messagingSenderId: "41037604264",
  appId: "1:41037604264:web:5b600fdd6a8155196fe99d"
};

const firebase = initializeApp(firebaseConfig);
const database = getDatabase(firebase);

// Vue.config.productionTip = false;

// Create the Vue app
const app = createApp(App);
app.config.globalProperties.$db = database;

// Use the router
app.use(router);

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: false,
        }
    }
});

// Mount the app
app.mount('#app');